import { Point } from './Utils';
export module Constants{
    export var ORIGIN : Point = [0,0];
    export var TWO_PI : number = 2 * Math.PI;
    export var TRANSPARENT : number = 0;
    export var OPAQUE : number = 1.0;
}

export module Paths{
    export var SCRIPT_LIBRARY : string = '../external/';
}